// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const PlayIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path d="M20 41.01l22.486-12.243L20 16.96z"/>
          <path d="M28.966-.015c-16.017 0-29 12.983-29 29 0 16.016 12.983 29 29 29 16.016 0 29-12.984 29-29s-12.984-29-29-29zM46.91 46.928c-4.794 4.793-11.166 7.433-17.944 7.433s-13.15-2.64-17.943-7.432C6.23 42.136 3.59 35.763 3.59 28.986c0-6.778 2.64-13.15 7.433-17.943C15.816 6.25 22.188 3.61 28.966 3.61s13.15 2.64 17.943 7.432c4.792 4.793 7.43 11.165 7.43 17.943 0 6.778-2.638 13.15-7.43 17.943z"/>
        </svg>
      )
    }
  </Icon>
);

export default PlayIcon;
